import ApiService from "@/utils/api.service";

export default {
    sendTokenToServer(context, params) {
        return new Promise(resolve => {
            context.dispatch("app/setLoading", true, { root: true });
            ApiService.post("pay", params)
                .then(({ data }) => {
                    //context.commit("setService", data);
                    resolve(data);
                })
                .finally(() => {
                    context.dispatch("app/setLoading", false, { root: true });
                });

        })
    }
}